import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';

import { tokens } from '../../tokens';

interface WrapperProps {
    $back?: boolean;
}

export const Wrapper = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})<WrapperProps>`
    z-index: ${tokens.zindex.temp};
    position: absolute;
    top: ${tokens.spacing.tight}px;
    right: ${tokens.spacing.tight}px;

    ${({ $back }) =>
        $back &&
        css`
            right: unset;
            left: ${tokens.spacing.tight}px;
        `};
`;
